/*
 * @Author: wyh
 * @Date: 2019-06-11 20:03:02
 * @Last Modified by: wyh
 * @Last Modified time: 2019-09-06 20:38:25
 * @Description: 路由跳转服务
 */
import { Injectable } from "@angular/core";
import { App, ViewController, NavController } from "ionic-angular";

@Injectable()
export class RouterService {
  private forwardParams = {
    animate: true,
    animation: "ios-transition",
    direction: "forward",
  }; //页面跳转通用参数

  private backParams = {
    animate: true,
    animation: "ios-transition",
    direction: "back",
  }; //页面返回参数

  constructor(private appCtrl: App) {}

  /**
   * 页面跳转
   * @param url 跳转地址
   * @param params 传入目标地址参数
   */
  forwardBlack(url: any, params?: any, forward?) {
    if (forward) {
      this.appCtrl.getRootNav().push(url, params, { animate: false });
    } else {
      this.appCtrl.getRootNav().pop({ animate: false });
    }
    // return this.appCtrl.getActiveNav().push(url, params, this.forwardParams);
  }

  /**
   * 页面跳转
   * @param url 跳转地址
   * @param params 传入目标地址参数
   */
  forward(url: any, params?: any, back?): Promise<any> {
    const animate = back ? this.backParams : this.forwardParams;
    return this.appCtrl.getRootNav().push(url, params, animate);
    // return this.appCtrl.getActiveNav().push(url, params, this.forwardParams);
  }

  /**
   * 页面返回
   */
  back(): Promise<any> {
    return this.appCtrl.getRootNav().pop(this.backParams);
    // return this.appCtrl.getActiveNav().pop(this.backParams);
  }

  /**
   * 返回至root页面
   */
  popToRoot(): Promise<any> {
    return this.appCtrl.getRootNav().popToRoot(this.backParams);
    // return this.appCtrl.getActiveNav().popToRoot(this.backParams);
  }

  /**
   * 从弹出页面跳转
   * @param url 跳转地址
   * @param params 传入目标地址参数
   */
  rootForward(url: string, params?: Object): Promise<any> {
    // this.viewCtrl.dismiss();
    return this.appCtrl.getRootNav().push(url, params, this.forwardParams);
  }

  /**
   * 设置根组件
   * @param url 跳转地址
   * @param params 传入目标地址参数
   */
  setRoot(url: any, params?: any): Promise<any> {
    return this.appCtrl.getRootNav().setRoot(url, params, this.forwardParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/common/router/router.services.ts